<script>
import { MasterlinkTenantServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
const mtsp = new MasterlinkTenantServiceProxy()
export default {
  data: () => ({
    current: 1,
    size: 20,
    tenantInfo: '',
    dataSource: [],
    currentTenantId: '',
    total: 0
  }),
  watch: {
    currentTenantId: {
      handler(val) {
        const current = this.dataSource.find((item) => item.tenantId === val)
        // 返回id，name，classes
        this.$emit('onChoose', current)
      }
    },
    current: {
      handler(val) {
        this.loadData()
      }
    },
    size: {
      handler(val) {
        this.loadData()
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      const { current, size, tenantInfo } = this.$data
      const res = await mtsp.getTenants(undefined, current, size, undefined, tenantInfo)
      console.log(res)
      this.dataSource = res.data.records
      this.total = res.data.total
      this.choose(this.dataSource[0].tenantId)
    },
    choose(tenantId) {
      this.currentTenantId = tenantId
    },
    search(e) {
      if (e.key === 'Enter') {
        this.loadData()
        e.target.blur()
        this.changeSize(1, this.size)
      }
    },
    changeSize(current, size) {
      console.log(current, size)
      this.size = size
      this.current = current
    }
  },
  render() {
    return (
      <div class="wapper">
        <a-input
          allowClear
          v-model={this.tenantInfo}
          placeholder="请输入关键词"
          style="width: calc(100% - 16px); margin: 8px"
          onKeypress={this.search}
        />
        <ul class="list">
          {this.dataSource.map((item) => {
            return (
              <li
                class={{
                  item: true,
                  active: this.currentTenantId === item.tenantId
                }}
                onClick={() => this.choose(item.tenantId)}
              >
                {item.tenantName}
              </li>
            )
          })}
        </ul>
        <a-pagination
          v-model={this.current}
          pageSize={this.size}
          total={this.total}
          show-size-changer
          style="text-align: right"
          onShowSizeChange={this.changeSize}
          // pageSizeOptions={['5', '10']}
        />
      </div>
    )
  }
}
</script>

<style lang="less" scoped>
.list {
  height: calc(100% - 110px);
  overflow: auto;
  .item {
    line-height: 32px;
    padding: 0 16px;
    cursor: pointer;
  }
  .active {
    background-color: #d0edff;
  }
}
.wapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
